import { BookingTool } from "@/components/booking/BookingTool";
import { isEmbedded } from "@/lib/embed";
import { PreviewLayout } from "@/components/PreviewLayout";
import PublicReviewsList from "@/components/PublicReviewsList";

export default function BookGuest() {
  const embedded = isEmbedded();
  const params = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");
  const showReviews = params.get("reviews") === "1";

  if (embedded) {
    // Chromeless embed — booking tool only, no headers/branding.
    return (
      <div className="min-h-screen">
        <main className="px-4 sm:px-6 lg:px-10 py-6 max-w-7xl mx-auto w-full">
          <BookingTool mode="guest" />
          {showReviews && (
            <div className="mt-10 pt-10 border-t border-slate-800">
              <PublicReviewsList compact />
            </div>
          )}
        </main>
      </div>
    );
  }

  return (
    <PreviewLayout tab="book">
      <div className="mb-8 animate-in-up">
        <h1 className="font-display text-3xl sm:text-4xl font-black text-white uppercase tracking-wide">Book a Station</h1>
        <p className="text-slate-400 mt-2 text-base sm:text-lg">Pick your rig, enter your details and pay securely — done in under a minute.</p>
      </div>
      <BookingTool mode="guest" />
    </PreviewLayout>
  );
}
